import React from "react";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import DirectionsRunRoundedIcon from "@mui/icons-material/DirectionsRunRounded";
import { Button, Stack, Typography } from "@mui/material";

export default function PersonPrimaryActions({
  sprintActive,
  partnerName,
  primaryBusy,
  onMessageAction,
  onSprintAction,
}) {
  const firstName = String(partnerName || "them").trim().split(/\s+/)[0] || "them";

  return (
    <Stack spacing={0.9}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.2}>
        <Button
          variant="contained"
          size="large"
          startIcon={<ChatBubbleOutlineRoundedIcon />}
          onClick={onMessageAction}
          sx={{ minWidth: 176, borderRadius: 999, fontWeight: 800, textTransform: "none" }}
        >
          Message {firstName}
        </Button>
        <Button
          variant="outlined"
          size="large"
          startIcon={<DirectionsRunRoundedIcon />}
          onClick={onSprintAction}
          disabled={primaryBusy}
          sx={{ minWidth: 164, borderRadius: 999, fontWeight: 800, textTransform: "none" }}
        >
          {primaryBusy ? "Opening..." : sprintActive ? "Open Accountability" : "Start Accountability"}
        </Button>
      </Stack>
      <Typography variant="body2" sx={{ color: "#68788d", fontWeight: 700, px: 0.4 }}>
        Say something quick or take one small step together.
      </Typography>
    </Stack>
  );
}
